import { colors } from "../../styles/theme"
import { EventCategory } from "./types"

interface CategoryListProps {
  categories: EventCategory[]
  selectedCategory: string
  onCategorySelect: (categoryId: string) => void
  getBracketStatusColor: (status: string) => string
  getBracketStatusLabel: (status: string) => string
}

export function CategoryList({ 
  categories, 
  selectedCategory, 
  onCategorySelect, 
  getBracketStatusColor, 
  getBracketStatusLabel 
}: CategoryListProps) {
  if (categories.length === 0) return null

  return (
    <div
      className="mt-6 border rounded-xl"
      style={{ backgroundColor: colors.background.secondary, borderColor: colors.border.primary }}
    >
      <div className="p-4 border-b" style={{ borderColor: colors.border.primary }}>
        <h3 className="text-sm font-medium" style={{ color: colors.text.primary }}>
          Racing Categories
        </h3>
      </div>
      <div className="p-2">
        <div className="space-y-1">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => onCategorySelect(category.id)}
              className={`w-full text-left p-3 rounded-lg transition-colors border ${
                selectedCategory === category.id
                  ? "border-rose-500"
                  : "border-transparent hover:border-gray-600"
              }`}
              style={{
                backgroundColor: selectedCategory === category.id ? colors.primary[950] : "transparent",
                borderColor: selectedCategory === category.id ? colors.primary[500] : "transparent",
              }}
            >
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-sm font-medium" style={{ color: colors.text.primary }}>
                  {category.name}
                </h4>
                <span
                  className="text-xs px-2 py-1 rounded-md uppercase"
                  style={{ backgroundColor: colors.background.tertiary, color: colors.text.secondary }}
                >
                  {category.vehicle_type}
                </span>
              </div>
              <div
                className="flex items-center justify-between text-xs mb-2"
                style={{ color: colors.text.secondary }}
              >
                <span className="font-medium" style={{ color: colors.status.success }}>
                  {category.prize_pool}
                </span>
                <span>
                  {category.participants}/{category.max_participants}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <div
                  className={`text-xs px-2 py-1 rounded-md border ${getBracketStatusColor(category.bracket_status)}`}
                >
                  {getBracketStatusLabel(category.bracket_status)}
                </div>
                {category.bracket_status !== "not_started" && (
                  <span className="text-xs" style={{ color: colors.text.secondary }}>
                    Round {category.current_round}/{category.total_rounds}
                  </span>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
} 